import { render } from "./BuscadorGlobal.vue?vue&type=template&id=7f968a63&scoped=true"
import script from "./BuscadorGlobal.vue?vue&type=script&lang=js"
export * from "./BuscadorGlobal.vue?vue&type=script&lang=js"

import "./BuscadorGlobal.vue?vue&type=style&index=0&id=7f968a63&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f968a63"]])

export default __exports__